import { render, staticRenderFns } from "./collmonitor.vue?vue&type=template&id=aa8573bc&scoped=true&"
import script from "./collmonitor.vue?vue&type=script&lang=js&"
export * from "./collmonitor.vue?vue&type=script&lang=js&"
import style0 from "./collmonitor.vue?vue&type=style&index=0&id=aa8573bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8573bc",
  null
  
)

export default component.exports